function PathBenefits() {
    this.$el = $('.path-benefits');

    if (this.$el.length) {
        this.setupDefaults();
        this.init();
    }
};

PathBenefits.prototype.setupDefaults = function () {
    this.width = 0;

    this.dom = {
        $stats: this.$el.find('.path-benefits__statistics-item-stat')
    }
};

PathBenefits.prototype.init = function () {
    var _this = this;

    this.dom.$stats.each(function(i, element) {
        if($(element).width() > _this.width) {
            _this.width = $(element).width();
        }
    });
    
    this.dom.$stats.width(this.width);
};

(function ($) {
    new PathBenefits();
})(jQuery);
